import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SweeperBullet = styled(Stack)(({ theme }) => ({
  backgroundColor:  `rgba(${theme.customColors.textPrimaryControlDisabled})`,
  // backgroundColor: theme.customColors.textPrimaryControlDisabled, //TODO ripristinare
  borderRadius: "1048575rem",
  boxShadow: "0 10px 15px -3px rgba(15, 217, 255, 0.25), 0 4px 6px -4px rgba(15, 217, 255, 0.25)",
  cursor: "pointer",
  height: "0.4375rem",
  transition: "all .1s linear",
  width: "0.4375rem"
}));
